"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// deps-lint-skip: empty
require("../../../style/index.less");
require("./index.less");
//# sourceMappingURL=index.js.map